import DocumentTitle from "react-document-title";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router";
import { useCurrentUser } from "../../data/hooks";
import Button from "../Components/Button";
import UserCard from "../Components/UserCard";
import { RoutePaths } from "../routes";
import MobileHeader from "../Components/MobileHeader";
import { selectIsSignedIn } from "@/data/redux/user/selectors";
import Spin from "../Components/Spin";
import { EditOutlined } from "@ant-design/icons";
import { ReactNode } from "react";

function Row({
  title,
  children,
}: {
  title: string;
  children?: string | ReactNode;
}) {
  return (
    <>
      <dt className="pt-4 font-bold">{title}</dt>
      <dd>{children}</dd>
    </>
  );
}

export default function Account() {
  const isSignedIn = useSelector(selectIsSignedIn);
  const { user, displayName, description, profileLoaded } = useCurrentUser();
  const navigate = useNavigate();

  if (!isSignedIn) {
    navigate(RoutePaths.login);
    return <></>;
  }

  if (!profileLoaded) {
    return <Spin />;
  }

  return (
    <DocumentTitle title="Profile">
      <>
        <MobileHeader title="Profile" />
        <div className="flex flex-col items-center gap-8 p-8 text-center">
          <UserCard id={user?.uid || ""} name={displayName} />
          <div>
            <dl>
              <Row title="Email (only visible to you)">
                {user?.email || ""}{" "}
                <Link
                  to={RoutePaths.accountEditEmail}
                  viewTransition
                  className="p-0"
                >
                  <EditOutlined />
                </Link>
              </Row>
              <Row title="About me">{description}</Row>
            </dl>
          </div>
          <Link to={RoutePaths.accountEdit} viewTransition>
            <Button light>Edit profile</Button>
          </Link>
          <Link to={RoutePaths.logout} viewTransition>
            <Button light>Log out</Button>
          </Link>
        </div>
      </>
    </DocumentTitle>
  );
}
